import React, { Component } from 'react';
import Toolbar from './components/Toolbar/Toolbar';
import SideDrawer from './components/SideDrawer/SideDrawer';
import Backdrop from './components/Backdrop/Backdrop';
import Home from './components/Pages/Home';
import About from './components/Pages/About';
import Book from './components/Pages/Book';
import Contact from './components/Pages/Contact';
import Faq from './components/Pages/Faq';
import Copyright from './components/Copyright/Copyright';
import ReactGA from 'react-ga';
import './App.css';

let p = window.location.href.split('?');

if(p.length >= 2) {
  if(p[1] !== 'Home' && p[1] !== 'About' && p[1] !== 'Book' && p[1] !== 'Faq' && p[1] !== 'Contact') {
    p = 'Home';
  } else {
    p = p[1];
  }
} else {
  p = 'Home';
}

ReactGA.initialize('UA-135786817-1');

class App extends Component {
  state = {
    sideDrawerOpen: false,
    currentPage: p,
    pages: {
      'Home': <Home/>,
      'About': <About/>,
      'Book': <Book/>,
      'Faq': <Faq/>,
      'Contact': <Contact/>,
      default: <Home/>
    }
  };

  drawerToggleClickHandler = () => {
    this.setState((prevState) => {
      return {sideDrawerOpen: !prevState.sideDrawerOpen}
    });
  }

  backdropClickHandler = () => {
    this.setState({sideDrawerOpen: false});
  }

  render() {
    let backdrop;

    if(this.state.sideDrawerOpen) {
      backdrop = <Backdrop click={this.backdropClickHandler}/>;
    }

    return (
      <div className="App">
        <Toolbar drawerClickHandler={this.drawerToggleClickHandler} page={this.state.currentPage}/>
        <SideDrawer  show={this.state.sideDrawerOpen}/>
        {backdrop}
        <main> 
          {this.state.pages[this.state.currentPage]}
          <Copyright/>
        </main>
      </div>
    );
  }
}

export default App;